import { useReactToPrint } from "react-to-print";
import { RECEIPT_PRINT_STYLES } from './receipts/printStyles';

const PrintContainer = ({
  children,
  contentRef,
  className,
  buttonLabel = "Imprimir",
  buttonClassName,
  pageStyle,
}) => {
  const handlePrint = useReactToPrint({
    contentRef,
    ignoreGlobalStyles: true,
    pageStyle: pageStyle || RECEIPT_PRINT_STYLES,
  });

  return (
    <div className={className}>
      <div ref={contentRef}>
        {children}
      </div>
      <button
        className={buttonClassName}
        onClick={handlePrint}
      >
        {buttonLabel}
      </button>
    </div>
  );
};

export default PrintContainer;
